import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectDealerMyCarParkById } from 'src/app/common/store/state/app.state';

import { selectMakes, selectModels, selectVersions } from 'src/app/common/store/state/app.state';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { CarEngine } from 'src/app/public/car/models/car-engine.model';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarModel } from 'src/app/public/car/models/car-model.model';
import { CarVersion } from 'src/app/public/car/models/car-version.model';
import { Car } from 'src/app/public/car/models/car.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBasicData } from 'src/app/public/car/constants/car-basic-data';

@Component({
    selector: 'app-post-new-car',
    templateUrl: './post-new-car.component.html',
    styleUrls: ['./post-new-car.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PostNewCarComponent {
  
  carId = '';
  formMessage = "";
  
  makes$: Observable<CarMake[]>;
  models$: Observable<CarModel[]>;
  versions$: Observable<CarVersion[]>;

  carYears: number[] = AppFunctions.getCarYearsBD();
  carBodyTypes = CarBasicData.bodyTypes;
  carGearBoxes = CarBasicData.gearboxes;
  carFuelTypes = CarBasicData.fuelTypes;

  disableSelect = new FormControl(false);
  car = new Car();

  currentCar$: Observable<any>;

  selectedVersion: CarVersion = new CarVersion('', '')
  
 
  constructor(

    private store: Store, 
    private router: Router, 
    private route: ActivatedRoute) {

      this.currentCar$ = store.select(selectDealerMyCarParkById(this.carId));
      this.makes$ = this.store.select(selectMakes);
      this.models$ = this.store.select(selectModels);
      this.versions$ = this.store.select(selectVersions);
    }

  ngOnInit(): void {
    
    this.currentCar$.subscribe(
    (c: Car) => {
      //if (c != undefined)
        //this.car = JSON.parse(JSON.stringify(c))
    });

    this.store.dispatch(CarRefActions.makesFetchSubmit( {}));

  }

  getCarModels(mk: string): string[]{
    return CarBasicData.getModelsBD([mk]);
  }

  
  onMakeChange(make: CarMake){
    //console.log(make);
    this.car.make = make.name;
    this.car.model = '';
    this.car.version = '';
    this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: [make.id] } ));
  }

  onModelChange(model: CarModel){
    this.car.model = model.name;
    this.car.version = '';
    this.store.dispatch(CarRefActions.versionsFetchSubmit( { modelIds: [model.id] } ));
  }

  onVersionChange(version: CarVersion){
    console.log(version);
    this.car.version = version.name;
    this.car.engine = '';
    this.car.gearBox = version.gearBox;

    this.selectedVersion = version;
  }

  onEngineChange(engine: CarEngine){
    console.log(engine);
    this.car.engine = engine.name;
    this.car.fuel = engine.fuel;
  }

  clearForm(){
    this.car = new Car();
  }

  submitForm() {

    console.log (this.car);

    //if (form.valid) {

      if(this.car.carId === ''){

        this.store.dispatch(DealerActions.createNewCarSubmit({car: this.car}));

      }
      else{

        this.store.dispatch(DealerActions.updateCarSubmit({carUpdates: this.car}));

      }
    //} 
  }  
}

/*
  carEditForm: FormGroup = new FormGroup( {
    id: new FormControl(this.car.carId, Validators.required),
    ownerId: new FormControl(this.car.ownerId, Validators.required),
    make : new FormControl(this.car.make, Validators.required),
    model : new FormControl(this.car.model, Validators.required),
    variant : new FormControl(this.car.variant, Validators.required),
    firstRegistration : new FormControl(this.car.firstRegistration, Validators.required),
    bodyType : new FormControl(this.car.bodyType, Validators.required),
    condition : new FormControl(this.car.condition, Validators.required),
    mileage : new FormControl(this.car.mileage, Validators.required),
    doors : new FormControl(this.car.doors, Validators.required),
    seats : new FormControl(this.car.seats, Validators.required),
    countryOrigin : new FormControl(this.car.countryOrigin, Validators.required),
    serviceHistory : new FormControl(this.car.serviceHistory, Validators.required),
    fuel : new FormControl(this.car.fuel, Validators.required),
    powerHp : new FormControl(this.car.powerHp, Validators.required),
    gearbox : new FormControl(this.car.gearbox, Validators.required),
    exteriorColor : new FormControl(this.car.exteriorColor, Validators.required),
    exteriorColorMetallic : new FormControl(this.car.exteriorColorMetallic, Validators.required),
    interiorColor : new FormControl(this.car.interiorColor, Validators.required),
    interiorMaterial : new FormControl(this.car.interiorMaterial, Validators.required),
    optionalEquipment : new FormControl(this.car.optionalEquipment, Validators.required),
    extraEquipment : new FormControl(this.car.extraEquipment, Validators.required),
    status : new FormControl(this.car.status, Validators.required),
    arrivalDate : new FormControl(this.car.arrivalDate, Validators.required),
    arrivalLocation : new FormControl(this.car.arrivalLocation, Validators.required),
    description : new FormControl(this.car.description, Validators.required),
    createdDate : new FormControl(this.car.createdDate, Validators.required),
    lastUpdatedDate : new FormControl(this.car.priceHistory[this.car.priceHistory.length - 1], Validators.required),
    price : new FormControl(this.car.priceHistory[this.car.priceHistory.length - 1], Validators.required),
    lastOffer : new FormControl(this.car.priceHistory[this.car.offerHistory.length - 1], Validators.required),
  }
  );
 */